import React from 'react'
import styled, { css } from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { FormControlProps, HintBoxProp } from '.'
import { srOnlyCss } from '../SrOnly'
import { InputWrapper } from '../TextField/styles'

export const Field = styled.div<Pick<FormControlProps, 'fullWidth' | 'gutterBottom' | 'disabled'>>`
  height: fit-content;
  position: relative;
  display: flex;
  flex-direction: column;
  ${({ fullWidth }) => fullWidth && `width: 100%;`}
  ${({ gutterBottom }) =>
    typeof gutterBottom === 'boolean' && gutterBottom === true
      ? `margin-bottom: 24px;`
      : `margin-bottom: ${!!gutterBottom ? `${gutterBottom}px` : gutterBottom};`}

  ${({ disabled }) =>
    disabled &&
    css`
      label {
        color: var(--gray-300);
      }

      input {
        background-color: var(--blueish-50);
        border-color: var(--blueish-200);
        color: var(--gray-300);
      }

      ${InputWrapper} {
        color: var(--gray-300);
      }
    `}
`

export const Label = styled.label<Pick<FormControlProps, 'error' | 'hiddenLabel' | 'disabled'>>`
  padding-bottom: 8px;
  color: ${({ error }) => `var(--${error ? 'red-500' : 'gray-800'})`};
  font-weight: 600;
  font-size: 0.8rem;

  .typography {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: inherit;
    color: inherit;
    font-size: 12px;
    span {
      font-size: inherit;
      color: inherit;
    }
  }

  ${({ hiddenLabel }) => hiddenLabel && srOnlyCss};
  cursor: auto;

  ${({ disabled }) =>
    disabled &&
    css`
      color: var(--gray-300);
      .typography > span {
        color: var(--gray-300);
      }
    `};

  .label-icon {
    margin-left: 4px;
  }
`

export const Hint = styled.small<{ gutterBottom?: number | boolean }>`
  margin-top: 0.25rem;
  font-size: 12px;
  font-weight: 400;
  line-height: 16.8px;
  color: var(--gray-700);
  ${({ gutterBottom }) =>
    !!gutterBottom && `margin-bottom: ${typeof gutterBottom === 'number' ? `${gutterBottom}px` : '24px'}`};
  strong {
    font-weight: 500;
  }
`

export const Error = styled.small.attrs((props) => ({
  ...props,
  className: `error${` ${props.className}`}`,
}))`
  position: absolute;
  bottom: -17px;
  left: 0;
  font-size: 11px;
  color: var(--critical-0);
`

export const Required = styled.abbr.attrs((props) => ({
  ...props,
  children: props.children || '*',
}))`
  margin-left: 0.25rem;
  color: var(--critical-0);
`
export const HintBox = styled.div.attrs<HintBoxProp>((props) => ({
  ...props,
  children: (
    <>
      {props.icon && <FontAwesomeIcon icon={props.icon} />}
      <p>{props.title}</p>
    </>
  ),
}))<HintBoxProp>`
  ${({ color }) => color && `background-color: var(--${color});`}
  width: 100%;

  margin-top: 8px;

  border: 1px solid var(--blueish-200);
  border-radius: 8px;

  padding: 16px;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  color: var(--blueish-800);
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;

  p {
    margin: 0;
  }
`
